/* cart-photo-thumbs.js
 * Converts "Photo: <url>" / "Preview: <url>" lines into thumbnails, in place.
 * Survives cart re-renders via observer + interval safety net.
 */
(function () {
  if (window.__cartPhotoThumbsInit) return;
  window.__cartPhotoThumbsInit = true;

  var URL_TOKEN = 'cdn.shopify.com/s/files/';
  var LABEL_RE = /^(photo\s*\d?\s*:|preview\s*:)$/i;

  function process() {
    var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT);
    var hits = [];
    var n;
    while ((n = walker.nextNode())) {
      if (n.nodeValue.indexOf(URL_TOKEN) !== -1 && !n.__cptDone) {
        hits.push(n);
      }
    }
    hits.forEach(function (t) {
      t.__cptDone = true;
      var url = t.nodeValue.trim();
      if (!url) return;

      var img = document.createElement('img');
      img.src = url;
      img.className = 'cart-photo-thumb';
      img.alt = 'Product photo';
      img.style.cssText = 'width:80px;height:80px;object-fit:cover;border-radius:6px;display:block;margin-top:4px;max-width:100%;';

      var parent = t.parentElement;
      if (!parent) return;

      // swap the URL text node for the image, in place
      parent.insertBefore(img, t);
      parent.removeChild(t);

      // if the parent now holds only a leftover label ("Photo:" / "Preview:"),
      // hide the parent and move the image out so it isn't hidden with it
      var rest = (parent.textContent || '').replace(url, '').trim();
      if (LABEL_RE.test(rest) || rest === '') {
        if (img.parentNode === parent) parent.removeChild(img);
        parent.style.display = 'none';
        parent.insertAdjacentElement('afterend', img);
      }
    });
  }

  function start() {
    process();
    var pending = null;
    new MutationObserver(function () {
      if (pending) clearTimeout(pending);
      pending = setTimeout(process, 50);
    }).observe(document.body, { childList: true, subtree: true });
    setInterval(process, 750);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
